<script setup>
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
  modelValue: {
    type: [Array, String],
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  mainColor: {
    type: String,
    required: true,
  },
  backgroundColor: {
    type: String,
    required: true,
  },
  textFont: {
    type: String,
    default: 'null',
  },
});

const emit = defineEmits(['update:modelValue']);

const valPriv = ref('');
const selectOptionsPriv = ref([...props.items]);

const model = computed({
  get() {
    return Array.isArray(props.modelValue)
      ? props.modelValue
      : [props.modelValue];
  },
  set(val) {
    emit('update:modelValue', Array.isArray(props.modelValue) ? val : val[0]);
  },
});

function addVal() {
  if (valPriv.value) {
    if (Array.isArray(model.value)) {
      model.value.push(valPriv.value);
    } else {
      model.value = [valPriv.value];
    }
    const index = selectOptionsPriv.value.indexOf(valPriv.value);
    if (index !== -1) {
      selectOptionsPriv.value.splice(index, 1);
    }
    valPriv.value = '';
  }
}

function removeVal(valToRemove) {
  if (Array.isArray(model.value)) {
    const index = model.value.indexOf(valToRemove);
    if (index > -1) {
      model.value.splice(index, 1);
      selectOptionsPriv.value.push(valToRemove);
    }
  } else {
    model.value = [];
  }
}

onMounted(() => {
  if (typeof props.modelValue === 'string') {
    model.value = [props.modelValue];
  }
});
</script>

<template>
  <div class="input">
    <p v-if="$slots.default" class="custom-font">
      <slot></slot>
    </p>
    <div class="input input-form core-default-input-form">
      <div class="elements">
        <div v-for="value in modelValue" :key="value" class="element">
          {{ value }}
          <q-icon name="remove_circle" @click="removeVal(value)" />
        </div>
      </div>
      <div class="input-add">
        <q-input v-model="valPriv" class="input" borderless> </q-input>
        <q-icon name="add_circle" @click="addVal" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './inputs';

.input-form {
  border: 1px solid v-bind(mainColor);
  background-color: v-bind(backgroundColor);
}

.input {
  width: 100%;
}

.elements {
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  margin: 7px 0;

  .element {
    display: flex;
    flex-direction: row;
    gap: 3px;
    justify-content: center;
    align-items: center;
  }
}

.input-add {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.custom-font {
  font-family: v-bind(textFont), 'Petit Formal Script', serif;
}
</style>
